import React, { Component, useState } from 'react';
import { StyleSheet, View, Image } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import Colors from '../../constants/Colors';
import Text from '../text';

const Loader = (props) => {
  const { loading, isContractGenerating, isContractSending, isRentalOfferSaving, isRenewed } = props;
  let sourceImage = null;

  if (isContractGenerating) {
    sourceImage = require('../../assets/images/hubita_contract_generating.gif');
  } else if (isContractSending) {
    sourceImage = require('../../assets/images/drone-contract-hubita.gif');
  } else if (isRentalOfferSaving) {
    if (!isRenewed) {
      sourceImage = require('../../assets/images/helloimage1/save-contract-hubita.gif');
    } else {
      sourceImage = require('../../assets/images/helloimage1/save-contract-hubita-renewal.gif');
    }
  }

  return (
    <Modal isVisible={loading} backdropTransitionInTiming={2000} backdropTransitionOutTiming={2000} fullScreen={true}>
      <View style={styles.modalBackground}>
        {sourceImage ? (
          <Image
            source={sourceImage}
            style={styles.gifStyle}
            resizeMode="contain"
          />
        ) : (
          <View style={styles.activityIndicatorWrapper}>
            <View style={{ padding: 8, backgroundColor: 'white', marginBottom: 20, borderRadius: 10 }}>
              <Image
                source={require('../../assets/gif/loading.gif')}
                style={{ height: 150, width: 150 }}
                resizeMode="contain"
              />
            </View>

          </View>
        )}
      </View>
    </Modal>
  );
};
const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  activityIndicatorWrapper: {
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  gifStyle: {
    width: 450,
    height: 450,
  },
});

export default Loader;
